import { __extends } from "tslib";
import React from 'react';
import { Url } from '@wix/da-url';
import BasePopup from './BasePopup';
import { withMobileContext } from '../Context';
var SIZE_DESKTOP = { width: 800, height: 500 };
var SIZE_MOBILE = { width: 327, height: 600 };
var SisuIframePopupSocial = /** @class */ (function (_super) {
    __extends(SisuIframePopupSocial, _super);
    function SisuIframePopupSocial() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SisuIframePopupSocial.prototype.render = function () {
        var _a = this.props, token = _a.token, authMode = _a.authMode, requestClose = _a.requestClose, isMobile = _a.isMobile;
        var size = isMobile ? SIZE_MOBILE : SIZE_DESKTOP;
        var url = Url.origin() + "/_sisu/modals/social/?auth_mode=" + authMode + "&token_id=" + token;
        return (React.createElement(BasePopup, { width: size.width, height: size.height, iframeSrc: url, requestClose: requestClose }));
    };
    return SisuIframePopupSocial;
}(React.Component));
export default withMobileContext(SisuIframePopupSocial);
//# sourceMappingURL=SisuIframePopupSocial.js.map